import { Col, Container, Image, Row } from "react-bootstrap"
import { FORMA_LOGO_NO_BG_BLACK } from "../../globals"

export const InitialLogo = () => {
	return (
		<Container style={{marginTop:"5vh"}}>
			<Row>
				<Col>
					<Image
						alt="logo"
						src={FORMA_LOGO_NO_BG_BLACK}
						id="slide-topLogo"
						data-aos="fade-down"
						data-aos-delay="0"
						data-aos-duration="500"
						data-aos-mirror="false"
						data-aos-once="true"
					></Image>
				</Col>
			</Row>
		</Container>
	)
}